import { useEffect, useRef, useState } from 'react';
import { NebulaHouseAd } from './NebulaHouseAd';
import { loadAdSenseScript } from '../utils/loadAdSenseScript';

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

interface AdSlotProps {
  className?: string;
  compact?: boolean;
}

/** `house` (défaut en dev) = pub Nebula Rush ; `adsense` = Google AdSense. */
const AD_MODE = import.meta.env.VITE_AD_MODE ?? 'house';
const AD_SLOT = (import.meta.env.VITE_ADSENSE_SLOT || '').trim();

function AdSenseSlot({ className }: AdSlotProps) {
  const pushed = useRef(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadAdSenseScript()
      .then(() => {
        if (!cancelled) setReady(true);
      })
      .catch(() => {
        /* script bloqué ou indisponible */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!ready || pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      /* AdSense non chargé ou bloqué */
    }
  }, [ready]);

  if (!ready) return null;

  return (
    <div className={className ?? 'ad-slot-wrap'}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-3964040172117553"
        {...(AD_SLOT ? { 'data-ad-slot': AD_SLOT } : {})}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}

export function AdSlot({ className, compact = false }: AdSlotProps) {
  if (AD_MODE === 'adsense') {
    return <AdSenseSlot className={className} />;
  }
  return <NebulaHouseAd className={className} compact={compact} />;
}
